<template>
<v-main>
    <transition appear>
      <p class="text-h4 text-center welcome" v-if="welif">Welcome</p>
    </transition>
</v-main>
    
</template>

<script>
import Vue from 'vue'
import VueMq from 'vue-mq'

Vue.use(VueMq, {
  breakpoints: { // default breakpoints - customize this
    sp: 959,
    pc: 960
  },
  defaultBreakpoint: 'pc' // customize this for SSR
})
export default{
    data(){
        return{
           welif: true 
        }
    },
    methods: {
        timeout: function(){
            setTimeout(() => {
                //console.log(this.$mq)
            }, 2000)
        },
        wel: function(){
            setTimeout(() => {
                this.welif = false
            }, 1000)
        }
    },
    mounted(){
        if(this.$mq == "sp") this.$router.push('/sp_home')
        else this.$router.push('/home')
        // this.wel()
        // this.timeout()
    }
}
</script>


<style scoped>
.v-enter-active, .v-leave-active {
  transition: opacity 1s;
}

.v-enter{
  opacity: 0;
}
.v-enter-to{
    opacity: 1;
}
.v-leave {
    opacity: 1;
}
.v-leave-to {
    opacity: 0;
}
.welcome{
    margin-top: 20%;
}

*{
  font-family:mplus-2c-medium;
}
</style>
